import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1160366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tournament-wrapper" }
const _hoisted_2 = {
  key: 0,
  id: "tournament"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "spacer" }, " ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "game game-spacer" }, " ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "spacer" }, " ", -1))
const _hoisted_6 = {
  key: 0,
  class: "round round-4"
}
const _hoisted_7 = { class: "game game-top champion" }
const _hoisted_8 = {
  key: 1,
  id: "tournament"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "round round-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "round round-2" }, null, -1))
const _hoisted_11 = { class: "round round-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "spacer" }, " ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "game game-spacer" }, " ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "spacer" }, " ", -1))
const _hoisted_15 = { class: "round round-4" }
const _hoisted_16 = { class: "game game-top third" }

import { Ref,  nextTick, onMounted, ref, watch } from 'vue'
import ffWebsiteAPI from '@/services/ff-website-api';

interface lbdataInfo {
id: number,
team_id: number
championships: number,
standing: number,
avgstanding: number,
first_name: string,
last_name: string,
full_name: string,
wins: number,
losses: number,
ties: number,
pf: number,
pa: number,
diff: number,
weeks_won: number,
seasons_won: number,
seed: number,
avgseed: number,
draft_pick: number,
avgdraft_pick: number,
}

interface mdataInfo {
  team_id: number,
  season: number,
  week: number,
  playoff: boolean,
  first_name: string,
  last_name: string,
  full_name: string,
  wins: number,
  losses: number,
  ties: number,
  score: number,
  opp_score: number,
}

interface sdataInfo {
  playoff_team_num: number,
  playoff_week_start: number,
  season: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyBracket',
  props: ['year'],
  setup(__props) {

const props = __props



const tabledata: Ref<Array<lbdataInfo> | null> = ref(null);
const bracketdata: Ref<any | null> = ref(null);
const settingsdata: Ref<Array<sdataInfo> | null> = ref(null);
const playoff_team_num = ref(0);
const playoff_week_start = ref(0);
const season = ref(2023);
const matchupsdata: Ref<Array<mdataInfo> | null> = ref(null);

let teamMap = new Map<number, lbdataInfo>();
const scoreMap = new Map<number, Map<number, number>>();

onMounted(() => {
  ffWebsiteAPI.ready = new Promise(resolve => {
      ffWebsiteAPI.resolver = resolve;
  });
  ffWebsiteAPI.resolver(1)
  fetchBracket();
});

function buildBracket(matchupsdata_value: mdataInfo[]) {
  if (tabledata.value != null && tabledata.value.length > 0) {
    let reseed = (season.value >= 2022);
    let bracket : (lbdataInfo | undefined)[][][] = [[[], [], [], []], [[], []], [[]]];
    let team_num = playoff_team_num.value
    let team_counter = 0;
    teamMap = new Map<number, lbdataInfo>();
    tabledata.value.forEach((team: lbdataInfo) => {
        if (team.seed <= team_num && team.seed != null) {
          teamMap.set(team.seed, team)
          scoreMap.set(team.team_id, new Map<number, number>())
        }
        else {
          let null_team: lbdataInfo = {
                team_id: 0,
                full_name: ' ',
                standing: 0,
                seed: team_num - team_counter,
            };
          if (team_counter < team_num) {
            teamMap.set(team_num - team_counter, null_team)
          }
        }
        team_counter++
    });

    matchupsdata_value.forEach((matchup: mdataInfo) => {
      scoreMap.get(matchup.team_id)?.set(matchup.week, matchup.score)
    });

    var team_data: lbdataInfo | undefined = undefined;

    for (let i = 0; i < (8/2); i++) {
      bracket[0][i] = [team_data, team_data]
      bracket[0][i][0] = (teamMap.get(i+1))
      bracket[0][i][1] = (teamMap.get(8-i))
    }
    
    for (let round_no = 0; round_no < bracket.length-1; round_no++) {
      bracket[round_no].reverse()
      let top_seed: (lbdataInfo | undefined)[] | undefined = bracket[round_no].pop();
      if (top_seed != undefined) {
        bracket[round_no].unshift(top_seed)
      }

      let winners : Array<lbdataInfo | undefined> = [];
      for (let i = 0; i < bracket[round_no].length; i++) {
        let winner: lbdataInfo;
        winner = findWinner(bracket[round_no][i], round_no);
        if (!reseed) {
          let is_odd = (i) % 2
          if (round_no == 0) {
            if (is_odd !== 0) {
              bracket[round_no][i].reverse();
            }
          }
          (i > 1) ? bracket[round_no + 1][i - is_odd - 1][is_odd] = winner : bracket[round_no + 1][i - is_odd][is_odd] = winner
        }
        else {
          winners.push(winner);
        }
      }
      if (reseed) {
        winners.sort((a, b) => a.seed - b.seed);

        let j = 0;
        while (winners.length > 1) {
          const highSeed = winners.shift()!;
          const lowSeed  = winners.pop()!;
          bracket[round_no + 1][j][(j + 2) % 2] = highSeed;
          bracket[round_no + 1][j][(j + 3) % 2] = lowSeed;
          j++;
          }
        }
      }
    return bracket
  }
  else if (tabledata.value != null && tabledata.value.length == 0) {
    return null
  }
}


async function fetchBracket() {
    try {
      const leaderboard_response = await ffWebsiteAPI.getLeaderboard(props.year);
      tabledata.value = leaderboard_response;
      const settings_response = await ffWebsiteAPI.getSettings(props.year);
      settingsdata.value = settings_response;
      if (settingsdata.value != null) {
        playoff_team_num.value = settingsdata.value[0].playoff_team_num
        playoff_week_start.value = settingsdata.value[0].playoff_week_start
        season.value = settingsdata.value[0].season
      }
      const matchups_response = await ffWebsiteAPI.getMatchups(props.year, null, null, 1)
      matchupsdata.value = matchups_response;
      if (matchupsdata.value != undefined) {
        bracketdata.value = buildBracket(matchupsdata.value);
      }
      await nextTick()
    }
    catch (e) {
      console.log(e)
    }
}

watch(() => props.year, () => {
  fetchBracket();
})

function findScore(team1: lbdataInfo | undefined, team2: lbdataInfo | undefined, round_index: number) : string | undefined {
  if (team1 == undefined || team2 == undefined) {
    return ""
  }
  else {
    if (teamMap.has(team1.seed)) {
      var team = teamMap.get(team1.seed)
      if (team != undefined) {
        var team_scores = scoreMap.get(team.team_id)
        if (team_scores != undefined && team_scores.has(playoff_week_start.value+round_index)) {
          return Number((team_scores?.get(playoff_week_start.value+round_index)))?.toFixed(2)
        }
      }
    }
    return undefined
  }
}

function findWinner(matchup: (lbdataInfo)[], round_index: number): (lbdataInfo) {
  let team1 = matchup[0]
  let team2 = matchup[1]
  if (team1 == undefined || team2 == undefined) {
        return (team1 == undefined) ? team2 : team1
  }
  else {
        if (findScore(team1, team2, round_index) != undefined) {
          if (Number(findScore(team1, team2, round_index)) > Number(findScore(team2, team1, round_index))) {
            return team1;
          }
          else {
            return team2;
          }
        }
        else {
          let null_team: lbdataInfo = {
                team_id: 0,
                full_name: '',
                standing: 0,
                seed: 0,
            };
          return null_team;
        }
    }
}

function findLoser(matchup: (lbdataInfo | undefined)[], round_index: number): (lbdataInfo) {
  let team1 = matchup[0]
  let team2 = matchup[1]
  if (findScore(team1, team2, round_index) != undefined) {
    if (Number(findScore(team1, team2, round_index)) > Number(findScore(team2, team1, round_index))) {
      return team2;
    }
    else {
      return team1;
    }
  }
  else {
    let null_team: lbdataInfo = {
                team_id: 0,
                full_name: '',
                standing: 0,
                seed: 0,
            };
    return null_team;
  }
}

function findThirdPlaceMathcup(bracket: (lbdataInfo | undefined)[] | undefined): (lbdataInfo | undefined)[]  {
  if (bracket != undefined) {
    let team1 = findLoser(bracket[bracket.length-2][0], bracket.length-2)
    let team2 = findLoser(bracket[bracket.length-2][1], bracket.length-2)
    return [team1, team2]
  }
  else {
    return [undefined, undefined]
  }
}

function findTeam(team: lbdataInfo | undefined) : string {
  if (team !== undefined) {
    return (team.full_name != "") ? `(${team.seed}) ${team.full_name}` : ""
  }
  else {
    return '\u00A0\u00A0\u00A0BYE';
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, _toDisplayString(__props.year) + " Playoff Bracket", 1),
    _createElementVNode("div", _hoisted_1, [
      (bracketdata.value)
        ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bracketdata.value, (round, round_index) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: round_index,
                class: "round"
              }, [
                _hoisted_3,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round, (game, game_index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: game_index }, [
                    _createElementVNode("li", {
                      class: _normalizeClass([(round.length != 1) ? 'game game-top' :  ((props.year != '2022') && (game[0] != undefined && (findLoser(game, Number(round_index)).seed == game[0].seed))) ? 'game game-top second' : 'game game-top', (game[0] != undefined && findWinner(game, Number(round_index)) != undefined && game != undefined && (findWinner(game, Number(round_index)).seed == game[0].seed) && !(props.year == 2022 && round_index == 2)) ? 'game winner' : 'game'])
                    }, [
                      _createTextVNode(_toDisplayString(findTeam(game[0])), 1),
                      _createElementVNode("span", null, _toDisplayString(findScore(game[0], game[1], Number(round_index))), 1)
                    ], 2),
                    _hoisted_4,
                    _createElementVNode("li", {
                      class: _normalizeClass([(round.length != 1) ? 'game game-bottom' : ((props.year != '2022') && (game[1] != undefined && (findLoser(game, Number(round_index)).seed == game[1].seed))) ? 'game game-bottom second' : 'game game-bottom', (game[1] != undefined && (findWinner(game, Number(round_index)) != undefined) && game != undefined && (findWinner(game, Number(round_index)).seed == game[1].seed)) ? 'game winner' : 'game'])
                    }, [
                      _createTextVNode(_toDisplayString(findTeam(game[1])), 1),
                      _createElementVNode("span", null, _toDisplayString(findScore(game[1], game[0], Number(round_index))), 1)
                    ], 2),
                    _hoisted_5
                  ], 64))
                }), 128))
              ]))
            }), 128)),
            (bracketdata.value)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, _toDisplayString((props.year != "2022") ? findTeam(findWinner(bracketdata.value[bracketdata.value.length-1][0], bracketdata.value.length-1)) : findTeam(findWinner(bracketdata.value[bracketdata.value.length-1][0], bracketdata.value.length-1))+' / '+findTeam(findLoser(bracketdata.value[bracketdata.value.length-1][0], bracketdata.value.length-1))), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (bracketdata.value)
        ? (_openBlock(), _createElementBlock("main", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("ul", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("li", {
                class: _normalizeClass(['game game-top', ((findThirdPlaceMathcup(bracketdata.value)[0] != undefined) && (findWinner(findThirdPlaceMathcup(bracketdata.value), bracketdata.value.length-1).seed == (findThirdPlaceMathcup(bracketdata.value)[0]).seed)) ? 'game winner' : 'game'])
              }, [
                _createTextVNode(_toDisplayString(findTeam(findThirdPlaceMathcup(bracketdata.value)[0])) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(findScore(findThirdPlaceMathcup(bracketdata.value)[0], findThirdPlaceMathcup(bracketdata.value)[1], bracketdata.value.length-1)), 1)
              ], 2),
              _hoisted_13,
              _createElementVNode("li", {
                class: _normalizeClass(['game game-bottom', (findThirdPlaceMathcup(bracketdata.value)[1] != undefined && (findWinner(findThirdPlaceMathcup(bracketdata.value), bracketdata.value.length-1).seed == (findThirdPlaceMathcup(bracketdata.value)[1]).seed)) ? 'game winner' : 'game'])
              }, [
                _createTextVNode(_toDisplayString(findTeam(findThirdPlaceMathcup(bracketdata.value)[1])), 1),
                _createElementVNode("span", null, _toDisplayString(findScore(findThirdPlaceMathcup(bracketdata.value)[1], findThirdPlaceMathcup(bracketdata.value)[0], bracketdata.value.length-1)), 1)
              ], 2),
              _hoisted_14
            ]),
            _createElementVNode("ul", _hoisted_15, [
              _createElementVNode("li", _hoisted_16, _toDisplayString(findTeam(findWinner(findThirdPlaceMathcup(bracketdata.value), bracketdata.value.length-1))), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})